/* eslint-disable react/prop-types */
import {
  Document,
  Page,
  StyleSheet,
  Text,
  View,
  Font,
} from "@react-pdf/renderer";
import React from "react";
import { chunkSubstr } from "../../utils/constants";
const defaultFont = "Roboto"; // Set the font family name
// Regular 400 font. The URL should be publicly accessible
// const regularFont =
//   "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@1,500&display=swap";
const regularFont =
  "https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmSU5vAw.ttf";

Font.register({
  family: defaultFont,
  fonts: [
    {
      src: regularFont,
      fontWeight: 200,
    },
    {
      src: regularFont,
      fontWeight: 300,
    },
    {
      src: regularFont,
      fontWeight: 400,
    },
    {
      src: regularFont,
      fontWeight: 500,
    },
    {
      src: regularFont,
      fontWeight: 600,
    },
  ],
});

export default function PDFDownload({
  tableHeaders,
  tableData,
  widthPercentPDF,
  title,
  orientaitionPage,
  subRow,
  dicSizeBreakWord,
}) {
  const keysValue = React.useMemo(() => {
    let keys = [];
    if (tableData?.length > 0) {
      keys = Object.keys(tableData[0]);
    }
    return keys;
  }, [tableData]);
  const styles = StyleSheet.create({
    page: {
      flexDirection: "row",
      backgroundColor: "#E4E4E4",
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    boxPage: {},
    table: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      height: "auto",
    },
    title: {
      width: "100%",
      padding: "6px 0",
      fontWeight: 600,
      color: "#1a73e8",
      fontFamily: "Roboto",
      textAlign: "center",
    },
    subRow: {
      width: "100%",
      paddingBottom: "4px",
      fontWeight: 500,
      fontFamily: "Roboto",
      textAlign: "center",
      fontSize: "14px",
    },
    tableRow: {
      margin: "auto",
      flexDirection: "row",
    },
    tableCell: {
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tabelHeaderCell: {
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      backgroundColor: "#ccc",
    },
    headerCell: {
      fontWeight: 600,
      fontSize: "13px",
      textAlign: "center",
      fontFamily: "Roboto",
      padding: "4px",
    },
    font: {
      fontFamily: "Roboto",
      fontSize: "13px",
      padding: "4px",
    },
    header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: "center",
      color: "grey",
    },
    pageNumber: {
      position: "absolute",
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: "center",
      color: "grey",
    },
  });
  const validateNumberData = (tableData, key) => {
    const isAllNumber = tableData
      .map((smItem) => smItem[key])
      .every(
        (ssmIttem) =>
          (!isNaN(parseFloat(ssmIttem)) && isFinite(ssmIttem)) ||
          typeof ssmIttem === "number"
      );
    return isAllNumber ? "center" : "left";
  };
  try {
    return (
      tableData?.length > 0 &&
      tableHeaders?.length > 0 &&
      keysValue?.length > 0 && (
        <Document>
          <Page
            size="A3"
            style={styles.page}
            orientation={orientaitionPage ? orientaitionPage : "portrait"}
          >
            <View style={styles.boxPage}>
              <View style={styles.title}>
                <Text>{title}</Text>
              </View>
              <View style={styles.subRow}>
                {subRow?.length > 0 &&
                  subRow?.map((sub, index) => (
                    <Text key={`subRow${index}`}>
                      {sub?.sub} {sub?.value}
                    </Text>
                  ))}
              </View>
              <View style={styles.table}>
                {/* Header */}
                <View style={styles.tableRow}>
                  <View
                    style={{
                      ...styles.tabelHeaderCell,
                      width: orientaitionPage == "landscape" ? "5%" : "4%",
                    }}
                  >
                    <Text style={styles.headerCell}>STT</Text>
                  </View>
                  {tableHeaders.map((header, index) => (
                    <View
                      key={`header-${index}`}
                      style={{
                        ...styles.tabelHeaderCell,
                        width: `${widthPercentPDF[index]}%`,
                      }}
                    >
                      <Text style={styles.headerCell}>{header}</Text>
                    </View>
                  ))}
                </View>

                {/* Data Rows */}
                {tableData.map((item, index) => (
                  <View key={`row-${index}`} style={styles.tableRow}>
                    <View
                      style={{
                        ...styles.tableCell,
                        textAlign: "center",
                        width: orientaitionPage == "landscape" ? "5%" : "4%",
                      }}
                    >
                      <Text style={styles.font}>{index + 1}</Text>
                    </View>
                    {keysValue.map((key, i) => (
                      <View
                        key={`cell-${index}-${i}`}
                        style={{
                          ...styles.tableCell,
                          width: `${widthPercentPDF[i]}%`,
                          textAlign: `${validateNumberData(tableData, key)}`,
                        }}
                      >
                        <Text style={styles.font}>
                          {dicSizeBreakWord?.[key]
                            ? chunkSubstr(
                                typeof item[key] == "number"
                                  ? item?.[key]?.toLocaleString("en-US")
                                  : item[key],
                                dicSizeBreakWord?.[key]
                              )
                            : typeof item[key] == "number"
                            ? item?.[key]?.toLocaleString("en-US")
                            : item[key]}
                          {/* {typeof item[key] == "number"
                            ? item?.[key]?.toLocaleString("en-US")
                            : item[key]} */}
                        </Text>
                      </View>
                    ))}
                  </View>
                ))}
              </View>
            </View>
            <Text
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) =>
                `${pageNumber} / ${totalPages}`
              }
              fixed
            />
          </Page>
        </Document>
      )
    );
  } catch (error) {
    console.error("Lỗi trong quá trình tạo PDF:", error);
    return <></>;
  }
}

// export default PDFDownload;
